import { SVGProps } from 'react';

const DemoTradingIcon = ({
  width = 26,
  height = 26,
  className,
}: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      className={className}
      data-palette="DemoTradingIcon">
      <path
        d="M4.33334 5.41667V17.3333H21.6667V5.41667H4.33334ZM2.16668 4.34144C2.16668 3.73866 2.65993 3.25 3.24113 3.25H22.7589C23.3523 3.25 23.8333 3.73633 23.8333 4.34144V19.5H2.16668V4.34144ZM1.08334 20.5833H24.9167V22.75H1.08334V20.5833Z"
        fill="var(--secondaryText)"
        stroke="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2467 14.7551V15.8207C10.2467 15.9216 10.2808 16.0059 10.349 16.0736C10.4172 16.1418 10.5015 16.1759 10.6019 16.1759C10.7023 16.1755 10.7866 16.1414 10.8548 16.0736C10.923 16.0059 10.9571 15.9216 10.9571 15.8207V14.7551H11.8039C11.9668 14.7551 12.1032 14.7007 12.2131 14.5917C12.323 14.4828 12.3779 14.3441 12.3779 14.1754V8.22515C12.3779 8.06223 12.323 7.92583 12.2131 7.81596C12.1032 7.70608 11.9668 7.65114 11.8039 7.65114H10.9571V6.58555C10.9571 6.48514 10.923 6.40084 10.8548 6.33264C10.7866 6.26445 10.7023 6.23035 10.6019 6.23035C10.5015 6.23035 10.4172 6.26445 10.349 6.33264C10.2808 6.40037 10.2467 6.48467 10.2467 6.58555V7.65114H9.3999C9.23698 7.65114 9.10058 7.70561 8.99071 7.81454C8.88083 7.92346 8.8259 8.06223 8.8259 8.23083V14.1811C8.8259 14.3441 8.88083 14.4804 8.99071 14.5903C9.10058 14.7002 9.23698 14.7551 9.3999 14.7551H10.2467ZM11.6675 8.36154V14.0447H9.5363V8.36154H11.6675ZM15.3614 12.4818V14.9682C15.3614 15.0691 15.3955 15.1534 15.4637 15.2211C15.5319 15.2893 15.6162 15.3234 15.7166 15.3234C15.817 15.323 15.9013 15.2889 15.9695 15.2211C16.0377 15.1534 16.0718 15.0691 16.0718 14.9682V12.4818H16.9186C17.0815 12.4818 17.2179 12.4274 17.3278 12.3184C17.4376 12.2095 17.4926 12.0708 17.4926 11.9021V8.79344C17.4926 8.63053 17.4376 8.49413 17.3278 8.38425C17.2179 8.27438 17.0815 8.21944 16.9186 8.21944H16.0718V7.15384C16.0718 7.05344 16.0377 6.96914 15.9695 6.90094C15.9013 6.83274 15.817 6.79864 15.7166 6.79864C15.6162 6.79864 15.5319 6.83274 15.4637 6.90094C15.3955 6.96867 15.3614 7.05297 15.3614 7.15384V8.21944H14.5146C14.3517 8.21944 14.2153 8.27391 14.1054 8.38283C13.9955 8.49176 13.9406 8.63053 13.9406 8.79913V11.9078C13.9406 12.0708 13.9955 12.2071 14.1054 12.317C14.2153 12.4269 14.3517 12.4818 14.5146 12.4818H15.3614ZM16.7822 8.92984V11.7714H14.651V8.92984H16.7822Z"
        fill="#FD7D01"
      />
    </svg>)
  );
};

export default DemoTradingIcon;
